<script setup>
const props = defineProps({
  secondary: Boolean,
})
</script>

<template>
  <div class="section-top relative" :class="secondary ? 'secondary' : ''" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700">
    <p class="text-title"><slot></slot></p>
    <div class="section-top__underline flex absolute">
      <div v-for="i in 4" :key="i" class="section-top__line"></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.section-top {
  width: fit-content;
  height: fit-content;
  z-index: 2;
  &.secondary {
    .section-top__underline {
      width: 100%;
    }
  }
  p {
    text-transform: uppercase;
    background: linear-gradient(90deg, #306BFF 0%, #9EA4FD 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    transition: background .3s ease;
    &:hover {
      background: linear-gradient(90deg, #ffffff 0%, #ffffff 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  &__underline {
    left: 0;
    top: calc(100% + clamp(1px, 0.06vw, 5px));
    width: calc(100% + clamp(46px, 3.194vw, 230px));
    gap: clamp(4px, 0.278vw, 20px);
  }
  &__line {
    height: clamp(2px, 0.139vw, 10px);
    background: #FFF;
    &:nth-child(1) {
      width: 100%;
    }
    &:nth-child(2) {
      width: clamp(21px, 1.458vw, 105px);
    }
    &:nth-child(3) {
      width: clamp(9px, 0.625vw, 45px);
    }
    &:nth-child(4) {
      width: clamp(4px, 0.278vw, 20px);
    }
  }
}
</style>